module.exports = __webpack_public_path__ + "img/result_txt_c.4c75eceb.png";